/** 페이지 스크롤은 window가 아니라 Layout의 main.main_container가 담당한다. */
export function scrollPageToTop(behavior: ScrollBehavior = 'auto') {
  const main = document.querySelector<HTMLElement>('main.main_container');
  main?.scrollTo({ top: 0, behavior });
  window.scrollTo({ top: 0, behavior });
}
